import { MenuAddonCard } from '../menuAddonCard';
import Styles from './menuCategorySection.module.scss';

const chunkIntoColumns = (items, columns) => {
	const indexed = items.map((item, index) => ({ item, index }));

	if (columns <= 1) return [indexed];

	const rows = Math.ceil(items.length / columns);

	return Array.from({ length: columns }, (_, column) => (
		indexed.slice(column * rows, column * rows + rows)
	));
};

const MenuItem = ({
	item, categoryId, sectionIndex, index, items, itemRef, onItemClick
}) => (
	<div className={Styles.itemGroup}>
		<button
			type="button"
			ref={(el) => itemRef(categoryId, sectionIndex, index, el)}
			className={Styles.item}
			onClick={() => onItemClick(items, index)}
		>
			<div className={Styles.itemHeader}>
				<span className={Styles.itemName}>
					{item.isSignature && (
						<span className={Styles.signatureStar} aria-label="Cafe Signature">★</span>
					)}
					{item.title}
				</span>
				<span className={Styles.itemPrice}>{item.price}</span>
			</div>
			{item.description && <p className={Styles.itemDescription}>{item.description}</p>}
		</button>
		{item.addon && <MenuAddonCard variant="inline" {...item.addon} />}
	</div>
);

const MenuSection = ({
	section, categoryId, sectionIndex, itemRef, onItemClick
}) => {
	const { heading, subheading, items } = section;
	const columns = section.columns ?? 1;

	return (
		<div className={Styles.subsection}>
			{heading && <h3 className={Styles.heading}>{heading}</h3>}
			{subheading && <p className={Styles.subheading}>{subheading}</p>}
			<div
				className={columns > 1 ? Styles.itemsGrid : Styles.items}
				style={columns > 1 ? { '--menu-columns': columns } : undefined}
			>
				{chunkIntoColumns(items, columns).map((column, columnIndex) => (
					// eslint-disable-next-line react/no-array-index-key
					<div key={columnIndex} className={Styles.itemsColumn}>
						{column.map(({ item, index }) => (
							<MenuItem
								key={item.title}
								item={item}
								categoryId={categoryId}
								sectionIndex={sectionIndex}
								index={index}
								items={items}
								itemRef={itemRef}
								onItemClick={onItemClick}
							/>
						))}
					</div>
				))}
			</div>
		</div>
	);
};

export const MenuCategorySection = ({
	category, sectionRef, onItemClick, itemRef
}) => {
	const {
		id, description, sections, addons, note
	} = category;

	const hasSideColumn = Boolean(addons?.length || note);

	return (
		<section ref={sectionRef} data-category-id={id} className={Styles.section}>
			{hasSideColumn && (
				<div className={Styles.sideColumn}>
					{addons?.map((addon) => (
						<MenuAddonCard key={addon.title} {...addon} />
					))}
					{note && <p className={Styles.note}>{note}</p>}
				</div>
			)}
			<div className={Styles.mainColumn}>
				{description && <p className={Styles.description}>{description}</p>}
				{sections.map((section, sectionIndex) => (
					<MenuSection
						// eslint-disable-next-line react/no-array-index-key
						key={section.heading ?? sectionIndex}
						section={section}
						categoryId={id}
						sectionIndex={sectionIndex}
						itemRef={itemRef}
						onItemClick={onItemClick}
					/>
				))}
			</div>
		</section>
	);
};
